
import { Component, Watch } from 'vue-property-decorator';

import Booking from '@/views/Booking.vue';
import { SuppliersApi } from '@/api/SuppliersApi';

import { SupplierSearchResponse } from '@/interfaces/Suppliers';

@Component({
   components: {
      SearchInput: () => import('@/components/SearchInput.vue'),
   },
})
export default class View extends Booking {
   archive: boolean = false;

   activities: SupplierSearchResponse[] = [];

   mounted() {
      SuppliersApi.activities()
         .then(activities => {
            this.activities = activities;
         })
         .finally(() => {
            this.$store.commit('hideLoading');
         });
   }
}
